export const headerItems = [
    {
        title: { pl: 'OFERTA', en: 'OFFER' },
        url: '/',
    },
    {
        title: { pl: 'REALIZACJE', en: 'PROJECTS' },
        url: '/Realizacje',
    },
    {
        title: { pl: 'INWESTYCJE', en: 'INVESTMENTS' },
        url: '/Inwestycje',
    },
    {
        title: { pl: 'O NAS', en: 'ABOUT US' },
        sectionId: 'opening',
    },
    {
        title: { pl: 'KONTAKT', en: 'CONTACT' },
        sectionId: 'contact',
    },
];